var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m17.393 16.364h-16.604c-0.33206 0-0.49814-0.17032-0.66417-0.34092-0.16605-0.17042-0.16605-0.51134 0-0.85227l8.3022-14.829c0.16605-0.1705 0.33211-0.34103 0.66417-0.34103 0.33208 0 0.49816 0.17042 0.66417 0.34103l8.3022 14.829c0.16605 0.1704 0.16605 0.51143 0 0.85227-0.166 0.17061-0.33208 0.34092-0.66417 0.34092zm-15.893-1.2129h15.182l-7.5909-13.544-7.5909 13.544zm8.4211-4.9254v-3.7499c0-0.51143-0.33206-0.85227-0.83022-0.85227-0.49814 0-0.83022 0.34084-0.83022 0.85227v3.7499c0 0.51143 0.33208 0.85227 0.83022 0.85227 0.49816 0 0.83022-0.51134 0.83022-0.85227zm-0.16605 3.0702c0.16605-0.17042 0.33211-0.51124 0.33211-0.68185 0-0.17052-0.16608-0.51134-0.33211-0.68187-0.16605-0.1704-0.49811-0.34092-0.66417-0.34092-0.33206 0-0.49814 0.17052-0.66417 0.34092-0.16605 0.17042-0.33208 0.51134-0.33208 0.68187 0 0.17061 0.16608 0.51143 0.33208 0.68185 0.16605 0.17042 0.49814 0.34103 0.66417 0.34103 0.33208 0 0.49816-0.17061 0.66417-0.34103z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-771 -1194)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(694 772)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(77 421)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.90909 1.8182)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#323E48",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F8C723",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.90909 -1.8182)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon_warning.57263b6e.svg";
export { ForwardRef as ReactComponent };